import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/admin/styles/index.css';
//notice: index.css must be imported before App.tsx to enable style overrides
import App from '@link/admin/App';
import { StoreProvider, store } from '@link/admin/stores';
import '@link/admin/i18n';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
